import { css } from "theme/default/css";

export const setFlexDF = css`
  display: flex;
`;
